  <div id="flipdown" class="flipdown" style="width: 100%;"></div>

